require("./bootstrap");
require("./console/warning");
require("./console/hiring");
